// Email configuration
export const EMAIL = "Hello@annfro.com";
export const EMAIL_OBFUSCATED = "Hello@annfro.com"; // For obfuscation
export const EMAIL_SUBJECT = "New Dream Project";

// Social media links
export const SOCIAL_LINKS = {
  behance: "https://www.behance.net/AnnKolnbro",
  instagram: "https://www.instagram.com/annfroltsova/",
  telegram: "https://t.me/AnnFroCom",
};

// App Store links (app id from App Store Connect)
export const APP_STORE = {
  CHOOSERIGHT: "https://apps.apple.com/app/id6759388003",
};

// Routes
export const ROUTES = {
  HOME: "/",
  ABOUT: "/about",
  PROCESS: "/process",
  WORKS: "/works",
  PRIVACY: "/privacy-policy",
  CHOOSERIGHT_PRIVACY: "/chooseright/privacy-policy",
  WEBSITE_PRIVACY: "/website-privacy-policy",
  CHOOSERIGHT: "/chooseright",
  SUPPORT: "/support",
};

// Full URL for ChooseRight! Privacy Policy (canonical link)
export const CHOOSERIGHT_PRIVACY_URL = "https://annfro.com/chooseright/privacy-policy";

// Device detection constants
export const MOBILE_BREAKPOINT = 768;
export const TABLET_BREAKPOINT = 1024;
export const MOBILE_PROCESS_BREAKPOINT = 600;

// Performance thresholds
export const MIN_HARDWARE_CONCURRENCY = 4;

// Animation constants
export const ANIMATION_DURATION = {
  FAST: 0.3,
  NORMAL: 1,
  SLOW: 1.5,
};

export const BLUR_FILTERS = {
  LOW_PERFORMANCE: {
    DESKTOP: "blur(50px)",
    MOBILE: "blur(80px)",
  },
  NORMAL: {
    DESKTOP: "blur(100px)",
    MOBILE: "blur(200px)",
  },
};

// PageLoader colors
export const LOADER_COLORS = ["#cde052", "#ff2a83", "#35c8bf"];
